import PropTypes from 'prop-types';
import React from 'react';
import { Button, Space, notification } from 'antd';
import { v4 as uuidv4 } from 'uuid';
import { API } from '../../api';
import { getTemplateClientId } from '../../utils/util';

/**
 * Export groovy function to the shared function library.
 *
 * @param {*} groovyCode
 * @param {*} getData
 * @param {*} isNew
 */
async function exportGroovyFunc(groovyCode, getData, closeModal) {
  const fncId = uuidv4();
  const templateClientId = await getTemplateClientId();
  const params = {
    id: fncId,
    value: groovyCode,
    value_type: 'def',
    client_id: templateClientId,
  };

  const res = await API.post(`/stdlib/${fncId}`, params);

  notification.success({
    message: `Updated (${res.status})`,
  });

  await getData();

  closeModal();
}

const ExportGroovyFunc = props => {
  const { closeModal, groovyCode, getData } = props;
  return (
    <>
      <p>
        This will add your groovy function to the library so it will be used across all clients.
        Continue?
      </p>
      <Space>
        <Button
          id="export-groovy-btn"
          type="primary"
          onClick={() => exportGroovyFunc(groovyCode, getData, closeModal)}
        >
          Save
        </Button>
        <Button>Cancel</Button>
      </Space>
    </>
  );
};

ExportGroovyFunc.propTypes = {
  closeModal: PropTypes.func.isRequired,
  getData: PropTypes.func.isRequired,
  groovyCode: PropTypes.string.isRequired,
};

export default ExportGroovyFunc;
